import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';


import { getEnvironment } from '../../../../src/app/environment/environment';
import { ENV } from '../../../../src/app/interfaces/interfaces';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { XtrasService } from '../../../../src/app/services/xtras.service';
import { ProjectConfigService } from '../../../../src/app/services/project-config.service';
import { InitializeAppService } from '../../../../src/app/services/initialize-app.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgClass,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  env:ENV = getEnvironment();
  title = this.env.title;

  constructor(
    public router: Router,
    private gtmService: GoogleTagManagerService,
    private initializeAppService: InitializeAppService,
  ) {
    this.initializeAppService.initializeApp();
    this.gtmService.addGtmToDom();
  }
}
